var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19976",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 21.334V19.2007C10.9444 19.0673 10.625 18.8312 10.375 18.4923C10.125 18.1534 10 17.7673 10 17.334V12.6673C10 12.4784 10.0639 12.3201 10.1917 12.1923C10.3194 12.0645 10.4778 12.0007 10.6667 12.0007H13.3333C13.5222 12.0007 13.6806 12.0645 13.8083 12.1923C13.9361 12.3201 14 12.4784 14 12.6673V17.334C14 17.7673 13.875 18.1534 13.625 18.4923C13.375 18.8312 13.0556 19.0673 12.6667 19.2007V21.334H13.3333C13.5222 21.334 13.6806 21.3979 13.8083 21.5257C13.9361 21.6534 14 21.8118 14 22.0007C14 22.1895 13.9361 22.3479 13.8083 22.4757C13.6806 22.6034 13.5222 22.6673 13.3333 22.6673H10.6667C10.4778 22.6673 10.3194 22.6034 10.1917 22.4757C10.0639 22.3479 10 22.1895 10 22.0007C10 21.8118 10.0639 21.6534 10.1917 21.5257C10.3194 21.3979 10.4778 21.334 10.6667 21.334H11.3333ZM11.3333 15.334H12.6667V13.334H11.3333V15.334ZM12 18.0007C12.1889 18.0007 12.3472 17.9368 12.475 17.809C12.6028 17.6812 12.6667 17.5229 12.6667 17.334V16.6673H11.3333V17.334C11.3333 17.5229 11.3972 17.6812 11.525 17.809C11.6528 17.9368 11.8111 18.0007 12 18.0007ZM16.6667 22.6673C16.3 22.6673 15.9861 22.5368 15.725 22.2757C15.4639 22.0145 15.3333 21.7007 15.3333 21.334V14.9673C15.3333 14.6784 15.4167 14.4201 15.5833 14.1923C15.75 13.9645 15.9667 13.8007 16.2333 13.7007L16.8667 13.4673C17.0222 13.4118 17.1389 13.3312 17.2167 13.2257C17.2944 13.1201 17.3333 12.9895 17.3333 12.834V10.0007C17.3333 9.81176 17.3972 9.65343 17.525 9.52565C17.6528 9.39787 17.8111 9.33398 18 9.33398H20C20.1889 9.33398 20.3472 9.39787 20.475 9.52565C20.6028 9.65343 20.6667 9.81176 20.6667 10.0007V12.834C20.6667 12.9895 20.7056 13.1201 20.7833 13.2257C20.8611 13.3312 20.9778 13.4118 21.1333 13.4673L21.7667 13.7007C22.0333 13.8007 22.25 13.9645 22.4167 14.1923C22.5833 14.4201 22.6667 14.6784 22.6667 14.9673V21.334C22.6667 21.7007 22.5361 22.0145 22.275 22.2757C22.0139 22.5368 21.7 22.6673 21.3333 22.6673H16.6667ZM18.6667 11.334H19.3333V10.6673H18.6667V11.334ZM16.6667 16.0007H21.3333V14.9673L20.7 14.734C20.2778 14.5784 19.9444 14.334 19.7 14.0007C19.4556 13.6673 19.3333 13.2895 19.3333 12.8673V12.6673H18.6667V12.8673C18.6667 13.2895 18.5444 13.6673 18.3 14.0007C18.0556 14.334 17.7222 14.5784 17.3 14.734L16.6667 14.9673V16.0007ZM16.6667 21.334H21.3333V20.0007H16.6667V21.334ZM16.6667 18.6673H21.3333V17.334H16.6667V18.6673Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.caa082c88243903764ede87ade3da3f8.svg";
export { ForwardRef as ReactComponent };